import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

let modulesFiles = require.context('./modules', true, /\.js$/)
let modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
  plugins: [createPersistedState({
    reducer(val) {
      return {
        users: val.user,
      }
    },
    storage: window.sessionStorage
  })],
  modules,
  state:{},
  mutations:{
  },
  key:'funtsata'
})

export default store




// WEBPACK FOOTER //
// ./src/store/index.js